module.exports = __webpack_public_path__ + "static/media/How to split PDF document.11e96624.png";